import { Directive } from '@angular/core';

// is used to get access to the HTML element, passed as the slider item
@Directive({
  selector: '.slider-item',
  standalone: true,
})
export class SliderItemElementDirective {
}
